// =========================================
// BY ZY — Content Data & Gallery Data
// =========================================

export const taglineSegments = [
  { text: 'Créer ', bold: false },
  { text: "l'impact. ", bold: true },
  { text: 'Filmer ', bold: false },
  { text: "l'émotion. ", bold: true },
  { text: 'Concevoir ', bold: false },
  { text: "l'expérience.", bold: true },
];

export const services = [
  {
    id: 'video',
    title: 'Production vidéo',
    description: 'Films de marque, pubs, contenus qui captent.',
    cta: 'Découvrir',
  },
  {
    id: 'web',
    title: 'Sites webs & Apps',
    description: 'Landing pages & apps rapides, belles, qui convertissent.',
    cta: 'Découvrir',
  },
];

export const introContent = {
  hint: 'Cliquez / Appuyez pour entrer',
  contentHeading: 'Que vous faut-il ?',
};

// =========================================
// Gallery: shared media items (test setup)
// 4 images + 1 video, reused per client
// Replace paths in /public/images/ later
// =========================================

const sharedItems = [
  { type: 'image', src: '/images/gallery-1.jpg' },
  { type: 'image', src: '/images/gallery-2.jpg' },
  { type: 'video', src: '/images/sample-video.webm', thumb: '/images/gallery-3.jpg' },
  { type: 'image', src: '/images/gallery-4.jpg' },
  { type: 'image', src: '/images/gallery-5.jpg' },
];

// State 3-A: Production vidéo clients
export const videoClients = [
  { name: 'Maxime L.', slug: 'maxime-l', items: [...sharedItems] },
  { name: 'Camille R.', slug: 'camille-r', items: [...sharedItems] },
  { name: 'Antoine B.', slug: 'antoine-b', items: [...sharedItems] },
  { name: 'Léa M.', slug: 'lea-m', items: [...sharedItems] },
  { name: 'Hugo P.', slug: 'hugo-p', items: [...sharedItems] },
  { name: 'Chloé D.', slug: 'chloe-d', items: [...sharedItems] },
];

// State 3-B: Sites webs & Apps clients
export const webClients = [
  { name: 'Sophie T.', slug: 'sophie-t', items: [...sharedItems] },
  { name: 'Nicolas F.', slug: 'nicolas-f', items: [...sharedItems] },
  { name: 'Emma V.', slug: 'emma-v', items: [...sharedItems] },
  { name: 'Lucas G.', slug: 'lucas-g', items: [...sharedItems] },
  { name: 'Juliette S.', slug: 'juliette-s', items: [...sharedItems] },
  { name: 'Thomas K.', slug: 'thomas-k', items: [...sharedItems] },
];

// Detail page metadata
export const detailMeta = {
  video: {
    label: 'GALLERY',
    title: 'Production vidéo',
    subtitle: 'Films, spots & contenus visuels réalisés pour nos clients.',
  },
  web: {
    label: 'GALLERY',
    title: 'Sites webs & Apps',
    subtitle: 'Projets digitaux conçus et développés sur mesure.',
  },
};
